<template>
  <div v-if="widgetsList" class="element-wrapper">
    <h6 class="element-header" v-if="!widget">{{ t('addWidgetHeader', 'addWidgetHeader') }}</h6>
    <h6 class="element-header" v-else>
      {{ t(widgetName, widgetName) }}
      <a class="os-icon os-icon-close remove-icon" :title="t('removeWidgetTooltip', 'removeWidgetTooltip')" href="javascript:;" v-if="widget && !widgetSelect" @click="removeWidget"></a>
      <a class="os-icon os-icon-pencil-2 mr-2 edit-icon" :title="t('editWidgetTooltip', 'editWidgetTooltip')" href="javascript:;" v-if="widget && !widgetSelect" @click="enableWidgetSelect"></a>
    </h6>
    <div class="col-12 element-box widget-box center-flex mt-0">
     <div class="col-12">
        <div class="text-center" v-if="!widgetSelect && !widget" style="cursor: pointer;" @click="enableWidgetSelect">
          <span class="os-icon os-icon-plus-circle add-widget"></span>
        </div>
        <div class="row">
          <div class="col-12 form-inline" v-if="widgetSelect" style="justify-content: center;">
            <div class="form-group">
              <select class="form-control form-control-sm" v-model="widget" @change="setWidget($event)">
                <option value="" disabled>{{ t('selectWidgetOption', 'selectWidgetOption') }}</option>
                <option v-for="item in widgetsList" :value="item.widget_name" :key="item.id">{{ t(item.translation_key, item.translation_key) }}</option>
              </select>
            </div>
            <button class="btn btn-primary ml-2" @click="saveWidget">{{ t('saveButtonLabel', 'saveButtonLabel') }}</button>
          </div>
        </div>
        <div class="row mt-2" v-if="widget">
          <div class="col-12">
            <component v-bind:is="widget"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Widgets
import BatchesStatusChart from '@/components/Widgets/BatchesStatusChart.vue'
import DocumentsOverviewStats from '@/components/Widgets/DocumentsOverviewStats.vue'
import PortalUseStats from '@/components/Widgets/PortalUseStats.vue'
import DeliveryMethodsChart from '@/components/Widgets/DeliveryMethodsChart.vue'
import ElectronicConversionsChart from '@/components/Widgets/ElectronicConversionsChart.vue'
import DocumentsCountChart from '@/components/Widgets/DocumentsCountChart.vue'
import EmailStatsChart from '@/components/Widgets/EmailStatsChart.vue'
import DocumentsPaymentsChart from '@/components/Widgets/DocumentsPaymentsChart.vue'
import WorkingCapitalCalculator from '@/components/Widgets/WorkingCapitalCalculator.vue'

export default {
  props: ['index'],
  data() {
    return {
      widgetViewName: 'unknown',
      widgetIndex: 0,
      widget: null,
      widgetSelect: false,
      showDropdown: false,
      widgetsList: null,
      widgetName: ''
    }
  },
  created() {
    this.getAvailableWidgets()

    if(this.$route.name) {
      this.widgetViewName = this.$route.name
    } else {
      this.widgetViewName = 'unknown'
    }
    if(this.$props.index) {
      this.widgetIndex = this.$props.index
    }

    this.loadWidget()
  },
  methods: {
    enableWidgetSelect() {
      this.widgetSelect = true
      this.showDropdown = true
    },
    saveWidget() {
      this.widgetSelect = false
      this.saveUserWidgets()
    },
    setWidget(event) {
      this.widgetName = event.target.selectedOptions[0].innerHTML
    },
    removeWidget() {
      this.$store.dispatch('widgetsStore/removeWidget', {
        widgetIndex: this.index,
        widgetName: this.$route.name,
      }).then(response => {
        this.widget = null
        this.widgetSelect = false
      })
    },
    saveUserWidgets() {
      this.$store.dispatch('widgetsStore/saveWidget', {
        widgetIndex: this.index,
        widgetName: this.$route.name,
        widget: this.widget
      })
    },
    loadWidget() {
      this.$store.dispatch('widgetsStore/loadWidget', {
        widgetIndex: this.index,
        widgetName: this.$route.name
      }).then(response => {
        if (response.data) { // fix console error when trying to access data.widget on null (data is null)
          if (response.data.widget) {
            this.widget = response.data.widget
          }
          if (response.data.widgetInfo) {
            this.widgetName = response.data.widgetInfo.translation_key
          }
        }
      })
    },
    getAvailableWidgets() {
      this.$store.dispatch('widgetsStore/getAvailableWidgets', null).then(response => {
        if (response.data) {
          if (response.data.length > 0) {
            this.widgetsList = response.data
          }
        }
      })
    }
  },
  components: {
    BatchesStatusChart,
    DocumentsOverviewStats,
    PortalUseStats,
    DeliveryMethodsChart,
    ElectronicConversionsChart,
    DocumentsCountChart,
    EmailStatsChart,
    DocumentsPaymentsChart,
    WorkingCapitalCalculator
  }
}
</script>

<style scoped>
.widget-box {
  min-height: 300px;
  position: relative;
}
.center-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-widget {
  font-size: 120px;
  color: #047bf8;
}
.edit-icon {
  text-decoration: none;
  float: right;
}
.remove-icon {
  text-decoration: none;
  color: red;
  float: right;
}
</style>
